<template>
    <transition name="animate" enter-active-class="animated fadeIn" leave-active-class="animated fadeOut" mode="out-in">
        <router-view></router-view>
    </transition>
</template>
<script>
    import axios from 'axios';
    import store from '../../../store/index';

    export default {
        // beforeRouteEnter(to, from, next) {
        //     axios.get('presupuesto/item/' + to.params.id, {params: to.params})
        //         .then(r => {
        //             store.dispatch('loading/setActive', false);
        //             if (r.data.tipo === 2) {
        //                 store.dispatch('notif/msjShow', r.data);
        //                 next(false);
        //             } else {
        //                 next();
        //             }
        //         })
        //         .catch(err => {
        //             store.dispatch('loading/setActive', false);
        //             next(false);
        //         })
        // },
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/pages/presup/item/index.vue